import React, { useState } from 'react';
import useInterval from '../../hooks/useInterval';
import { db } from '../../../firebase';
import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import style from './WhenNotAnswered.module.css';
const WhenNotAnswered = ({questionData }) => {
  const fifteenMinutesInMs = 15 * 60 * 1000;
  const [timePassed, setTimePassed] = useState(false);
  const userRef = doc(db, "questions",questionData.question_id);

  useInterval(() => {
    const timeDifference = new Date().getTime() - questionData.createdAt.toDate().getTime();

    if (timeDifference > fifteenMinutesInMs) {
      setTimePassed(true);
    }
  }, 1000);

  const handleClick = async () => {
    await updateDoc(userRef, { not_answered_alert: new serverTimestamp() });
  };


  if (!timePassed || !questionData) {
    return null;
  }

  if (questionData.not_answered_alert) {
    return <div className={'d-flex justify-content-center align-items-center flex-column mt-4'}>  Thank you for letting us know!
        <p><b><center>We're sorry for the delay. Your question will be taken with high priority</center>  </b></p>
        </div>;
  }

 

  return (
    <div className={'d-flex justify-content-center align-items-center '+style.notAnswered}>
      <hr/>
      <div>Is your question taking more than 15 minutes?</div>
      <button className='ml-30' onClick={handleClick}>Click Here</button>
    </div>
  );
};

export default WhenNotAnswered;
